const drawerWidth: number = 240;

export {drawerWidth};